import React from 'react'
import {
  TextField,
  Button
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import SearchIcon from '@mui/icons-material/Search'
import RotateLeftIcon from '@mui/icons-material/RotateLeftOutlined'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '50px 0 0 50px', // Bordes redondeados a la izquierda
      height: '56px' // Ajusta la altura del TextField
    },
    flexGrow: 1 // El TextField crece para ocupar más espacio
  },
  button: {
    borderRadius: '0 50px 50px 0', // Bordes redondeados a la derecha
    height: '100%', // Hace que el botón tenga la misma altura que el TextField
    minHeight: '56px'
  },
  iconButton: {
    borderRadius: '0', // Elimina los bordes redondeados entre el input y los botones
    height: '100%',
    minHeight: '56px'
  }
}))

interface SlimSearchBarProps {
  textFieldValue: string
  onChangeTextField: (text: string) => void
  onSearch: () => void
  onResetSearch: () => void
  buttonTitle: string
}

export const SlimSearchBar: React.FC<SlimSearchBarProps> = ({
  onSearch,
  onChangeTextField,
  onResetSearch,
  textFieldValue
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <TextField
        className={classes.textField}
        variant='outlined'
        placeholder='Escribe aquí'
        onChange={(e) => onChangeTextField(e.target.value)}
        value={textFieldValue}
      />
      <Button
        variant='contained'
        color='primary'
        className={classes.iconButton}
        onClick={onSearch}
      >
        <SearchIcon />
      </Button>
      <Button
        variant='contained'
        className={classes.button}
        onClick={onResetSearch}
      >
        <RotateLeftIcon />
      </Button>
    </div>
  )
}

export default SlimSearchBar
